import Vue from 'vue'
import App from './productimages.vue'
import axios from 'axios'
import { VLazyImagePlugin } from "v-lazy-image";

Vue.use(VLazyImagePlugin);

Vue.config.productionTip = false
Vue.prototype.$axios = axios

var list = document.getElementById("productimages");
new Vue({
  name : "productimages",
  data:{
    language : JSON.parse(list.dataset.language),
    admin : (list.dataset.admin == "true"),
    settings : list.dataset.settings != "" ? JSON.parse(list.dataset.settings) : {"showNoDownloads" : [], "exculdeFrontBackId" : []},
    flaptype : (list.dataset.flaptype),
    hidecat : list.dataset.hidecat != "" ? JSON.parse(list.dataset.hidecat) : "",
  },
  render: h => h(App),
}).$mount('#productimages')
